import { Button } from 'semantic-ui-react';
import { MODES, MONTH_NAMES } from '../periods.js';

/* Annual / Quarterly / Monthly buttons, then the selectors each one needs:
 * Annual (Year), Quarterly (Year, Quarter), Monthly (Year, Month). */
export default function PeriodPicker({ sel, years, onChange, disabled }) {
  const set = (patch) => onChange({ ...sel, ...patch });
  return (
    <div className="toolbar periodpicker" role="group" aria-label="Choose the period to view">
      <Button.Group>
        {MODES.map(([id, label]) => (
          <Button key={id} type="button" toggle active={sel.mode === id} aria-pressed={sel.mode === id} disabled={disabled}
            onClick={() => set({ mode: id })}>{label}</Button>
        ))}
      </Button.Group>
      <label htmlFor="pp-year">Year</label>
      <select id="pp-year" className="ui dropdown" value={sel.year} disabled={disabled} onChange={(e) => set({ year: Number(e.target.value) })}>
        {years.map((y) => <option key={y} value={y}>{y}</option>)}
      </select>
      {sel.mode === 'quarterly' && (
        <>
          <label htmlFor="pp-quarter">Quarter</label>
          <select id="pp-quarter" className="ui dropdown" value={sel.quarter} disabled={disabled} onChange={(e) => set({ quarter: Number(e.target.value) })}>
            {[0, 1, 2, 3].map((q) => <option key={q} value={q}>Q{q + 1}</option>)}
          </select>
        </>
      )}
      {sel.mode === 'monthly' && (
        <>
          <label htmlFor="pp-month">Month</label>
          <select id="pp-month" className="ui dropdown" value={sel.month} disabled={disabled} onChange={(e) => set({ month: Number(e.target.value) })}>
            {MONTH_NAMES.map((m, i) => <option key={m} value={i}>{m}</option>)}
          </select>
        </>
      )}
    </div>
  );
}
